var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.style(200)
  var g1 = _vm.imageList.length
  var l0 = _vm.__map(_vm.orderDetail.skuList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.imgs.length
    var m1 = _vm.style(200)
    return {
      $orig: $orig,
      g0: g0,
      m1: m1,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }